import React from 'react';
import PropTypes from 'prop-types';
import { formValidate } from 'eventbrite_design_system/utils/form';
import Button from 'eventbrite_design_system/button/Button';
import {
    TYPE_SUBMIT,
    STYLE_FILL,
    SIZE_BLOCK,
} from 'eventbrite_design_system/button/constants';
import LegalNotice from '../LegalNotice';
import PasswordField from '../PasswordField';

import { passwordValidate as validate } from '../utils';
import { SET_PASSWORD_FORM } from '../../constants';

const FormSubmitButton = ({ buttonCTA, isDisabled }) => (
    <div>
        <Button
            type={TYPE_SUBMIT}
            style={STYLE_FILL}
            size={SIZE_BLOCK}
            disabled={isDisabled}
        >
            {buttonCTA}
        </Button>
    </div>
);

class SetPasswordForm extends React.PureComponent {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        locale: PropTypes.string,
        shouldHideLegalCopy: PropTypes.bool,
        showNotification: PropTypes.func,
        clearNotification: PropTypes.func,
    };

    state = {
        isDisabled: true,
    };

    componentDidMount() {
        //eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ isDisabled: false });
    }

    componentWillReceiveProps({ submitting, submitFailed, error }) {
        const { showNotification, clearNotification } = this.props;

        /*If the form has an error and submit failed, attempt
        to display a notification*/
        if (submitFailed && error) {
            showNotification(error);
        }

        /*We want to limit only one error notification to
        appear per form submission if the user has dismissed it.
        So each time submitting is true, then reset the flag.*/
        if (submitting) {
            clearNotification();
        }
    }

    componentWillUnmount() {
        const { clearNotification } = this.props;

        clearNotification();
    }

    render() {
        const {
            handleSubmit,
            buttonCTA,
            submitting,
            submitSucceeded,
            shouldHideLegalCopy,
            locale,
        } = this.props;
        const { isDisabled } = this.state;
        const submitDisabled = isDisabled || submitting || submitSucceeded;

        return (
            <form onSubmit={handleSubmit}>
                <PasswordField
                    isLogin={false}
                    requiredPassword={true}
                    autoFocus={true}
                />
                <LegalNotice
                    locale={locale}
                    hideLegalNotice={shouldHideLegalCopy}
                />
                <FormSubmitButton
                    buttonCTA={buttonCTA}
                    isDisabled={submitDisabled}
                />
            </form>
        );
    }
}

export default formValidate({
    validate,
    form: SET_PASSWORD_FORM,
    destroyOnUnmount: false,
    touchOnBlur: false,
})(SetPasswordForm);
